import { Logger, LogLevel } from "@core/logger";
import { initializeLogger } from "../../core/config/config.initializer";
import { CommonState } from "../../core/interface/common-state";
import { useEffect, useState } from "react";
import { Dashboard } from "../../core/interface/dashboard";
import { CommonResponse } from "../../core/interface/common-response";
import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../../core/services/http-call.service";
import { getCurrentSelection, setConversationId, setCurrentSelection } from "../../core/services/user.service";
import { DashboardDetail } from "../../core/interface/dashboard-detail";
import { UserDashboard, UserDashboardList } from "../../core/interface/user-dashboard-list";
import { CurrentSelection } from "../../core/interface/current-selection";

export default function useProjectBulletinLogic() {

  let logger: Logger = initializeLogger();
  const [stateObject, setStateObject] = useState<CommonState>({
    showErrorModal: false, callInProgress: false, statusMessage: ''
  });
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const [dashboardList, setDashboardList] = useState<UserDashboardList[]>([]);
  const [projectDashboards, setProjectDashboards] = useState<Dashboard[]>([])

  useEffect(() => {
    setConversationId('')
    const loadProjectAndDashboardList = async () => {
      setStateObject({ ...stateObject, callInProgress: true });
      let dashList: UserDashboardList[] = await getProjectDashboardList();
      if (dashList.length > 0) {
        // pubSub.publish(EVENT_ID_BULLETIN_LIST, getUniqueDashboards(dashList).map(x => x.dashboardTitle));
        getDashboardListForProject(dashList[1].projectId.toString(), dashList[1].projectName);
        setStateObject({ ...stateObject, callInProgress: false });
      } else
        setStateObject({ showErrorModal: true, callInProgress: false, statusMessage: 'Unable to get user dashboard details.' });
    };

    loadProjectAndDashboardList();
  }, []);

  async function getProjectDashboardList() {
    let userDashboardList: UserDashboardList[] = [];
    let dashboardResp: CommonResponse = await axiosGet<CommonResponse>(import.meta.env.VITE_API_HOST + '/dashboard/user/all');
    logger.log(LogLevel.DEBUG, 'User access details', dashboardResp);

    if (dashboardResp.code == 'SUCCESS' && dashboardResp.data?.length > 0) {
      userDashboardList = dashboardResp.data;
      userDashboardList = [extractFavoriteDashboardList(userDashboardList), ...userDashboardList];
      setDashboardList(userDashboardList);
    }

    logger.log(LogLevel.DEBUG, 'user Dashboard list', userDashboardList)
    return userDashboardList;
  }

  // function getUniqueDashboards(projects: UserDashboardList[]): UserDashboard[] {
  //   const dashboardMap = new Map<number, UserDashboard>();

  //   projects.forEach(project => {
  //     project.dashboard.forEach(dashboard => {
  //       if (!dashboardMap.has(dashboard.dashboardId)) {
  //         dashboardMap.set(dashboard.dashboardId, dashboard);
  //       }
  //     });
  //   });

  //   return Array.from(dashboardMap.values());
  // };

  function extractFavoriteDashboardList(userDashList: UserDashboardList[]): UserDashboardList {
    let favoriteDashboards: UserDashboard[] = userDashList.flatMap(project => project.dashboard).filter(dashboard => dashboard.favourite);

    return {
      projectId: 0,
      projectName: "favorites",
      dashboard: favoriteDashboards
    };
  }

  /**
   * 
   */
  async function getDashboardListForProject(id: string, name: string) {

    setCurrentSelection({ id: id, name: name });
    let projDashListResp: CommonResponse = await axiosGet<CommonResponse>(import.meta.env.VITE_API_HOST + '/dashboard');

    if (projDashListResp.code == 'SUCCESS' && projDashListResp.data?.length > 0) {
      setProjectDashboards(projDashListResp.data);
    }
  }

  async function changeAndReload(id: string, name: string) {
    setStateObject({ ...stateObject, callInProgress: true });
    setCurrentSelection({ id: id, name: name });
    await getDashboardListForProject(id, name);
    setStateObject({ ...stateObject, callInProgress: false });
  }

  async function handleCloseModal() {
    setShowSaveModal(false);
    setStateObject({ ...stateObject, callInProgress: true });
    let currentSelection: CurrentSelection = getCurrentSelection();
    await getDashboardListForProject(currentSelection.id, currentSelection.name);
    setStateObject({ ...stateObject, callInProgress: false, showErrorModal: false, statusMessage: "" });
  };

  async function addFavouriteDashboard(dashboardId: string) {
    setStateObject({ ...stateObject, callInProgress: true });
    await axiosPut(import.meta.env.VITE_API_HOST + `/dashboard/favourite/${dashboardId}`);
    let currentSelection: CurrentSelection = getCurrentSelection();
    await getDashboardListForProject(currentSelection.id, currentSelection.name);
    await getProjectDashboardList();
    setStateObject({ ...stateObject, callInProgress: false });
  }

  async function duplicateDashboard(dashboardId: string) {
    setStateObject({ ...stateObject, callInProgress: true });
    let dashboardDetailResp: CommonResponse = await axiosGet(import.meta.env.VITE_API_HOST + `/dashboard/${dashboardId}`);
    let reqObj: DashboardDetail = dashboardDetailResp.data;

    reqObj.title = 'Copy of ' + reqObj.title
    await axiosPost(import.meta.env.VITE_API_HOST + '/dashboard', reqObj);
    let currentSelection: CurrentSelection = getCurrentSelection();
    await getDashboardListForProject(currentSelection.id, currentSelection.name);
    setStateObject({ ...stateObject, callInProgress: false });
  }

  async function deleteDashboard(dashboardId: string) {
    setStateObject({ ...stateObject, callInProgress: true });
    await axiosDelete(import.meta.env.VITE_API_HOST + `/dashboard/${dashboardId}`)
    let currentSelection: CurrentSelection = getCurrentSelection();
    await getDashboardListForProject(currentSelection.id, currentSelection.name);
    await getProjectDashboardList();
    setStateObject({ ...stateObject, callInProgress: false });
  }

  return {
    stateObject,
    dashboardList,
    projectDashboards,
    showSaveModal,
    changeAndReload,
    handleCloseModal,
    duplicateDashboard,
    deleteDashboard,
    setShowSaveModal,
    addFavouriteDashboard
  }

}

